import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  IconButton,
  Modal,
  Skeleton,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import AddIcon from "@mui/icons-material/Add";
import { useCallback, useEffect, useState } from "react";
import DashboardCard from "./DashboardCard";
import Issues from "./Issues";
import ShareIcon from "@mui/icons-material/Share";
import Activity from "./Activity";
import CheckIcon from "@mui/icons-material/Check";
// import LineCharts from './LineCharts';
// import Reminders from './Reminders';
// import TaskStatus from './TaskStatus';
// import TaskTime from './TaskTime';
// import TaskSummary from './TaskSummary';
import { Link } from "react-router-dom";

import { IssueType, Priority } from "../../services/stickerColor";
import Image from "../../components/Image";
import axiosInstance from "../../utilities/axios";
import { useProjectId } from "../../providers/ProjectProvider";
import RefreshIcon from "@mui/icons-material/Refresh";
import CreateIssues from "../issues/Board/CreateIssues";
import IssueSkeleton from "../issues/Board/createIssueSkeleton";
import { useMessage } from "../../providers/Provider";
import { useNavigate } from "react-router-dom";
function stripHtml(htmlString) {
  const tmp = document.createElement("div");
  tmp.innerHTML = htmlString;
  return tmp.textContent || tmp.innerText || "";
}
function TabPanel({ children, value, index }) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && (
        <Box p={1}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

const Index = () => {
  // const activityData = [
  //   {
  //     status: "Completed",
  //     description: "This is a demo Activity",
  //     fullName: "CP123",
  //     type: "issue",
  //   },
  //   {
  //     status: "Completed",
  //     description: "This is a demo Activity",
  //     fullName: "CP123",
  //     type: "comment",
  //   },
  //   {
  //     status: "Completed",
  //     description: "This is a demo Activity",
  //     fullName: "CP123",
  //     type: "organization",
  //   },
  //   {
  //     status: "Completed",
  //     description: "This is a demo Activity",
  //     fullName: "CP123",
  //     type: "member",
  //   },
  //   {
  //     status: "Completed",
  //     description: "This is a demo Activity",
  //     fullName: "CP123",
  //     type: "project",
  //   },
  // ];

  const [tabSelected, setTabSelected] = useState(0);
  const members = null;

  const tabHandleChange = (_event, newValue) => {
    setTabSelected(newValue);
  };
  const projectId = useProjectId();
  const [issues, setIssues] = useState([]);
  const [metrics] = useState({});
  // const [activity] = useState(activityData);
  const ORG_ID = localStorage.getItem("selectedOrganization");
  const [copyStates, setCopyStates] = useState(
    Array(metrics?.issues?.recent?.length).fill(false)
  );

  const [issueStats, setIssueState] = useState(null);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    const id = localStorage.getItem("selectedProject");
    if (projects.length && id) {
      const found = projects.find((p) => p._id === id);
      setSelectedProject(found);
    }
  }, [projects]);
  const statusColors = {
    "To Do": "#1976d2", // Blue
    Backlog: "#9e9e9e", // Grey
    "In Progress": "#ffa000", // Amber
    Review: "#7b1fa2", // Purple
    Done: "#388e3c", // Green
  };

  const todoIssues = issues.filter((issue) => issue.status === "To Do");
  const inProgressIssues = issues.filter(
    (issue) => issue.status === "In Progress"
  );
  const reviewIssues = issues.filter((issue) => issue.status === "Review");
  const doneIssues = issues.filter((issue) => issue.status === "Done");
  // const backlogIssues = issues.filter((issue) => issue.status === "Backlog");

  const fetchProjectIssues = async (projectId) => {
    try {
      const response = await axiosInstance.get(
        `/api/v2/projects/${projectId}/issues`
      );
      return response.data.issues || [];
    } catch (error) {
       // console.error("Failed to fetch issues:", error);
      return [];
    }
  };
  useEffect(() => {
    const loadIssues = async () => {
      const projectId = localStorage.getItem("selectedProject");
      const data = await fetchProjectIssues(projectId);
      setIssues(data);
    };
    loadIssues();
  }, []);
  const [activity, setActivity] = useState([]);
  const SINCE = new Date(
    new Date().setFullYear(new Date().getFullYear() - 1)
  ).toISOString();

  const [organizationId] = useState(
    localStorage.getItem("selectedOrganization")
  );

  const fetchProjects = useCallback(
    async function () {
      try {
        const selectedProject = localStorage.getItem("selectedProject");
        const response = await axiosInstance.get(
          `/api/v2/projects/organization/${organizationId}`
        );
        setProjects(response.data.projects);
      } catch (e) {
         // console.log(e);
      }
    },
    [setProjects]
  );
  const closeProject = () => {
    navigate("/view-project");
    setProjectState(false);
  };
  const [projectState, setProjectState] = useState(false);

   // console.log(projects, "projjj");
  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);
  useEffect(() => {
    const selectedProjectId = localStorage.getItem("selectedProject");
    if (!selectedProjectId) {
      setActivity([]);
      return;
    }
    axiosInstance
      .get(`/api/v2/activities/project/${selectedProjectId}`, {
        params: { since: SINCE, limit: 50 },
      })
      .then(({ data }) => {
        const activities = (data?.activities || []).map((a) => {
          let type;
          if (typeof a?.action === "string") {
            if (a.action.startsWith("issue.")) {
              type = a?.metadata?.type || "Task";
            } else if (a.action.startsWith("comment.")) {
              type = "comment";
            } else if (a.action.startsWith("project.")) {
              type = "project";
            }
          }
          if (!type) {
            type = (a?.entityType || "comment").toLowerCase();
            if (["bug", "task", "subtask"].includes(type)) {
              type = type[0].toUpperCase() + type.slice(1);
            }
          }
          const status = a?.metadata?.status || a?.metadata?.changed?.status || undefined;
          return {
            type,
            description: a?.description || "",
            time: a?.createdAt,
            status,
            correspondId: {
              project: a?.projectId,
              issue: a?.issueId,
              comment: a?.entityType === "Comment" ? a?.entityId : undefined,
            },
          };
        });
        const all = activities
          .sort((a, b) => new Date(b.time) - new Date(a.time))
          .slice(0, 10);
        setActivity(all);
      })
      .catch((err) => {
         // console.error("Failed to load project activities", err);
      });
  }, []);

  // const fetchMetrics = useCallback(
  //   async function () {
  //     try {
  //       const response = await axiosInstance.get(
  //         `/api/project-issue-stats/${projectId}/`
  //       );
  //        // console.log(response.data.data);

  //       setIssueState(response.data.data);
  //     } catch (e) {
  //        // console.log(e);
  //     }
  //   },
  //   [setIssueState, projectId]
  // );

  // useEffect(() => {
  //   fetchMetrics();
  // }, [fetchMetrics]);
  const [selectedIssue, setSelectedIssue] = useState(null);

  const handleCopy = (index) => {
    const currentURL = window.location.href;

    navigator.clipboard
      .writeText(currentURL)
      .then(() => {
        const newCopyStates = [...copyStates];
        newCopyStates[index] = true;
        setCopyStates(newCopyStates);

        setTimeout(() => {
          const resetCopyStates = [...newCopyStates];
          resetCopyStates[index] = false;
          setCopyStates(resetCopyStates);
        }, 3000);
      })
      .catch((error) => {
        if (error instanceof Error) {
           // console.log("Error copying URL to clipboard");
        }
      });
  };
  const [task, setTask] = useState(null);
  const [query, setQuery] = useState({
    assignee: "",
    priority: "",
    type: "",
    search: "",
  });
  const statuses = ["Backlog", "To Do", "In Progress", "Review", "Done"];
  const { showError, showSuccess } = useMessage();

  const fetchSelectedIssue = useCallback(
    async function () {
      try {
        const response = await axiosInstance.get(
          `/api/v2/issues/${projectId}/issue/${selectedIssue}`
        );
         // console.log(response.data, "response.data.data");

        setTask(response.data.data);
      } catch (e) {
         // console.log(e);
      }
    },
    [setTask, selectedIssue, projectId]
  );
  useEffect(() => {
    selectedIssue && fetchSelectedIssue();
  }, [fetchSelectedIssue, selectedIssue]);

  const [issueList, setIssueList] = useState({});

  const handleChangeQuery = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setQuery({ ...query, [name]: value });
  };
  const openIssueModal = (id) => {
    // const issue = issueList.find(issue => issue.id === id);
    setSelectedIssue(id);

    setProjectState(true);
  };

  const fetchIssues = useCallback(async () => {
    try {
      const params = {};

      if (query.priority) params.priority = query.priority;
      if (query.type) params.type = query.type;
      if (query.search) params.search = query.search;
      if (query.assignee) params.assignee = query.assignee;

      const response = await axiosInstance.get(
        `/api/v2/projects/${projectId}/issues`,
        { params }
      );

      const issuesList = {};
      for (const status of statuses) {
        issuesList[status] = [];
      }

      for (const issue of response.data.issues) {
        issuesList[issue.status].push(issue);
      }

      setIssueList(issuesList);
    } catch (e) {
       // console.log(e);
      showError("Failed to fetch issues");
    }
  }, [setIssueList, projectId, showError]);

   // console.log(issueStats);
  return (
    <Box>
      <Box sx={{ mt: 3, px: 2 }}>
        <Grid container spacing={4} display="flex" alignItems="center">
          <Grid item xs display="flex" alignItems="center">
            <Typography variant="h5"> Dashboard</Typography>
          </Grid>
          <Grid item display="flex" alignItems="center">
            <Link to="/create-project">
              <Button
                startIcon={<AddIcon fontSize="small" />}
                variant="contained"
                size="small"
              >
                Create new project
              </Button>
            </Link>
            <Box sx={{ ml: 2 }}>
              <Tooltip title="info" placement="top">
                <IconButton
                  // disableRipple
                  // variant='navIcon'
                  sx={{ mr: 0 }}
                >
                  <InfoIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          </Grid>
        </Grid>
        <Divider sx={{ mt: 1 }} />
      </Box>
      <Box
        sx={{
          height: {
            sm: "calc(100vh - 174px)",
            xs: "calc(100vh - 250px)",
          },
          overflow: "auto",
          px: 2,
        }}
      >
        <Box sx={{ mt: 4, mb: 1 }}>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs>
              <Typography variant="h6">Issues Updates</Typography>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                LinkComponent={Link}
                href={"/your-work"}
                sx={{
                  background: "#3b84d9",
                  "&:hover": {
                    background: "#3b84d9",
                  },
                }}
              >
                <RefreshIcon fontSize="small" />
              </Button>
            </Grid>
          </Grid>
        </Box>
        {/* Issues Data */}
        <Box mb={3}>
          <Grid container spacing={2}>
            {issues.map((issue, i) => (
              <Grid item lg={4} xl={3} sm={6} xs={12} key={issue._id}>
                <Card
                  sx={{
                    cursor: "pointer",
                    minHeight: "170px",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    borderRadius: "8px",
                    "&:hover": { backgroundColor: "custom.cardHover" },
                  }}
                  onClick={() => {
                    openIssueModal(issue._id);
                  }}
                >
                  <CardContent sx={{ p: 1, pb: 0 }}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          px: 1.5,
                          py: 0.3,
                          backgroundColor:
                            statusColors[issue.status] || "custom.cardHover",
                          color: "#fff",
                          borderRadius: "20px",
                          fontWeight: "bold",
                          textTransform: "capitalize",
                        }}
                      >
                        {issue.status}
                      </Typography>

                      <Tooltip title="Copy link">
                        <ShareIcon
                          fontSize="small"
                          sx={{ fontSize: 17 }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCopy(i);
                          }}
                        />
                      </Tooltip>
                    </Box>

                    <Box my={1} mt={1.5}>
                      <Typography
                        variant="body2"
                        color="text.tertiary"
                        sx={{
                          maxWidth: "100%",
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 2,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        Project: {selectedProject?.projectName} → Key:{" "}
                        {selectedProject?.projectKey}
                      </Typography>
                    </Box>

                    <Box my={1} mt={1.5}>
                      <Typography
                        variant="body2"
                        color="text.tertiary"
                        sx={{
                          maxWidth: "100%",
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 2,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        Issue: {issue.title}
                      </Typography>
                    </Box>

                    <Box>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        className="line-clamp-3 text-xs leading-snug"
                        dangerouslySetInnerHTML={{
                          __html:
                            issue?.description ||
                            "<p>No description provided</p>",
                        }}
                      ></Typography>
                    </Box>
                  </CardContent>

                  <Box
                    sx={{
                      p: 1.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Tooltip
                      title={
                        issue.assignee
                          ? issue.assignee.firstName +
                            " " +
                            issue.assignee.lastName
                          : "Unassigned"
                      }
                    >
                      <Avatar sx={{ width: 30, height: 30 }} />
                    </Tooltip>

                    <Box display="flex" alignItems="center" mt={1}>
                      <Tooltip title={`Priority: ${issue.priority}`}>
                        <Box>
                          <Image
                            name={Priority[issue.priority]}
                            sx={{ width: 20, height: 20, mr: 1 }}
                          />
                        </Box>
                      </Tooltip>

                      <Tooltip title={`Type: ${issue.type}`}>
                        <Box>
                          <Image
                            name={IssueType[issue.type]}
                            sx={{ width: 20, height: 20, mr: 1 }}
                          />
                        </Box>
                      </Tooltip>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Grid container spacing={2} mb={1}>
          {/* Activity Section */}
            {
              activity.length ? 

              
          <Grid item xs={12} lg={6}>
            <Card sx={{ height: "436px", borderRadius: "8px" }}>
              {/* make CardContent a column flex container */}
              <CardContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  p: 2,
                }}
              >
                {/* header stays at top */}
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ mb: 2 }}
                >
                  <Typography variant="h6">Activity</Typography>
                  <Link to="/your-work">
                    <Button variant="contained" size="small">
                      View All
                    </Button>
                  </Link>
                </Box>

                {/* scrollable content area */}
                <Box
                  sx={{
                    flex: 1, // take remaining vertical space
                    overflowY: "auto", // enable vertical scroll
                    pr: 1, // prevent content clipping under scrollbar
                  }}
                >
                  {activity.length ? (
                    <Activity activities={activity} members={members} />
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        height: "100%",
                      }}
                    >
                      <Box sx={{ width: "150px" }}>
                        <Image name="noActivity.svg" />
                      </Box>
                      <Typography
                        variant="h6"
                        color="text.secondary"
                        fontWeight="bold"
                        sx={{ mt: 1 }}
                      >
                        You currently have no Activity
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mt: 1 }}
                      >
                        Let's create your first activity in Clikkle Projects
                      </Typography>
                    </Box>
                  )}
                </Box>
              </CardContent>
            </Card>
          </Grid>: ""
            }


          {/* Issues Section */}
          <Grid item xs={12} lg={6}>
            <Card sx={{ height: "436px", borderRadius: "8px" }}>
              <CardContent>
                <Box
                  sx={{
                    borderLeftWidth: "5px",
                    borderLeftColor: "primary.main",
                    borderLeftStyle: "solid",
                    height: "40px",
                    width: "5px",
                    position: "absolute",
                    left: 1,
                  }}
                ></Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography variant="h6">Issues</Typography>
                  <Link to="/your-work">
                    <Button variant="contained" size="small">
                      View All
                    </Button>
                  </Link>
                </Box>
                <Box sx={{ my: 1 }}>
                  <Tabs
                    value={tabSelected}
                    onChange={tabHandleChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    aria-label="scrollable force tabs example"
                  >
                    <Tab label="To Do" />
                    <Tab label="In Progress" />
                    <Tab label="Review" />
                    <Tab label="Done" />
                    {/* <Tab label="Backlog" /> */}
                  </Tabs>
                </Box>
                <TabPanel value={tabSelected} index={0}>
                  {todoIssues.length > 0 ? (
                    <Issues issues={todoIssues} selectedProject={selectedProject?.projectName} />
                  ) : (
                    <NoIssuesMessage />
                  )}
                </TabPanel>
                <TabPanel value={tabSelected} index={1}>
                  {inProgressIssues.length > 0 ? (
                    <Issues issues={inProgressIssues} selectedProject={selectedProject?.projectName}/>
                  ) : (
                    <NoIssuesMessage />
                  )}
                </TabPanel>
                <TabPanel value={tabSelected} index={2}>
                  {reviewIssues.length > 0 ? (
                    <Issues issues={reviewIssues} selectedProject={selectedProject?.projectName} />
                  ) : (
                    <NoIssuesMessage />
                  )}
                </TabPanel>
                <TabPanel value={tabSelected} index={3}>
                  {doneIssues.length > 0 ? (
                    <Issues issues={doneIssues} selectedProject={selectedProject?.projectName} />
                  ) : (
                    <NoIssuesMessage />
                  )}
                </TabPanel>
                {/* <TabPanel value={tabSelected} index={3}>
          {backlogIssues.length > 0 ? <Issues issues={backlogIssues} /> : <NoIssuesMessage />}
        </TabPanel> */}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
      <Modal
        sx={{
          overflowY: "scroll",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        open={projectState}
        onClose={closeProject}
      >
        <>
          {task ? (
            <CreateIssues
              members={members}
              task={task}
              closeProject={closeProject}
              selectedIssue={selectedIssue}
              ProjectId={projectId}
              setProjectState={setProjectState}
              fetchIssues={fetchIssues}
            />
          ) : (
            <IssueSkeleton />
          )}
        </>
      </Modal>
    </Box>
  );
};

export default Index;

const NoIssuesMessage = () => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      height: "40vh",
      width: "100%",
    }}
  >
    <Box sx={{ width: "150px" }}>
      <Image name="noIssues.svg" />
    </Box>
    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
      Currently no issues in this status
    </Typography>
  </Box>
);

// const filterOptions = useMemo(
//     () => [
//         { name: 'Today', value: 'today' },
//         { name: 'This week', value: 'week' },
//         { name: 'This month', value: 'month' },
//         { name: 'This year', value: 'year' },
//     ],
//     []
// );
//  // console.log(projectId);

{
  /* <Grid container spacing={2} mt={2}>
                    {issueStats ? (
                        <DashboardCard issue={issueStats && issueStats} />
                    ) : (
                        Array(4)
                            .fill(0)
                            .map((_el, i) => (
                                <Grid item lg={6} xl={3} xs={12} key={i}>
                                    <Skeleton
                                        variant='rectangular'
                                        animation='wave'
                                        height='112px'
                                        sx={{
                                            borderRadius: '4px',
                                        }}
                                    />
                                </Grid>
                            ))
                    )}
                </Grid> */
}
{
  /* <Grid item lg={6} xl={6} xs={12}>
            <Card
              sx={{
                height: "436px",
                borderRadius: "8px",
              }}
            >
              <CardContent>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ mb: 3 }}
                >
                  <Typography variant="h6">Activity</Typography>{" "}
                  <Link to="/all-activity">
                    <Button variant="contained" size="small">
                      View All
                    </Button>
                  </Link>
                </Box>
                {activity.length ? (
                  <Activity activities={activity} members={members} />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                      height: "60vh",
                      width: "100%",
                    }}
                  >
                    <Box sx={{ width: "150px" }}>
                      <Image name="noActivity.svg" />
                    </Box>
                    <Typography
                      variant="h6"
                      color="text.secondary"
                      fontWeight="bold"
                      sx={{ mt: 1 }}
                    >
                      You currently have no Activity
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mt: 1 }}
                    >
                      Let's create your first activity in Clikkle Projects
                    </Typography>
                  </Box>
                )}
              </CardContent>
            </Card>
          </Grid> */
}

{
  /* ) : (
                        <Grid item lg={6} xl={6} xs={12}>
                            <Skeleton
                                variant='rectangular'
                                animation='wave'
                                height='436px'
                                sx={{
                                    borderRadius: '4px',
                                }}
                            />
                        </Grid>
                    )} */
}

{
  /* <Grid item lg={6} xl={6} xs={12}>
                            <Skeleton
                                variant='rectangular'
                                animation='wave'
                                height='436px'
                                sx={{
                                    borderRadius: '4px',
                                }}
                            />
                        </Grid> */
}
{
  /* <Grid container spacing={2} my={3}>
                <Grid item lg={4} xs={12}>
                    <Card sx={{ position: 'relative' }}>
                        <CardContent>
                            <Box
                                sx={{
                                    borderLeftWidth: '5px',
                                    borderLeftColor: 'primary.main',
                                    borderLeftStyle: 'solid',
                                    height: '40px',
                                    width: '5px',
                                    position: 'absolute',

                                    left: 1,
                                }}
                            ></Box>
                            <Typography>Statistics</Typography>
                            <LineCharts />
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item lg={4} xl={4} xs={12}>
                    <Card sx={{ position: 'relative' }}>
                        <CardContent>
                            <Box
                                sx={{
                                    borderLeftWidth: '5px',
                                    borderLeftColor: 'primary.main',
                                    borderLeftStyle: 'solid',
                                    height: '40px',
                                    width: '5px',
                                    position: 'absolute',

                                    left: 1,
                                }}
                            ></Box>
                            <Typography variant='h6' sx={{ mb: 3 }}>
                                Reminders
                            </Typography>
                            <Reminders
                                Background='pink.light'
                                Textcolor='pink.dark'
                            />

                            <Reminders
                                Background='lightGreen.light'
                                Textcolor='lightGreen.dark'
                            />

                            <Reminders
                                Background='orange.light'
                                Textcolor='orange.dark'
                            />

                            <Reminders
                                Background='skyBlue.light'
                                Textcolor='skyBlue.dark'
                            />

                            <Reminders
                                Background='blue.light'
                                Textcolor='blue.dark'
                            />
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item lg={4} xs={12}>
                    <TaskStatus />
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={12} lg={4}>
                    <TaskTime />
                </Grid>
                <Grid item lg={8} xs={12}>
                    <Card sx={{ position: 'relative' }}>
                        <CardContent>
                            <Box
                                sx={{
                                    borderLeftWidth: '5px',
                                    borderLeftColor: 'primary.main',
                                    borderLeftStyle: 'solid',
                                    height: '40px',
                                    width: '5px',
                                    position: 'absolute',

                                    left: 1,
                                }}
                            ></Box>
                            <Typography variant='h6' sx={{ mb: 3 }}>
                                Project Summary
                            </Typography>
                            <TaskSummary />
                        </CardContent>
                    </Card>
                </Grid>
            </Grid> */
}
